import type { ChatModelData } from './types';

export type SerializedChatModel = ChatModelData;

export class ChatModel {
  private readonly data: ChatModelData;

  constructor(data: ChatModelData) {
    this.data = { ...data };
  }

  get chatId(): string {
    return this.data.chatId;
  }

  get position(): number {
    return this.data.position;
  }

  get model(): string {
    return this.data.model;
  }

  serialize(): SerializedChatModel {
    return { ...this.data };
  }

  static fromSerialized(serialized: SerializedChatModel): ChatModel {
    return new ChatModel(serialized);
  }
}
